export const CRM_DATE_FORMAT = 'MMM D, YYYY'
export const SUBSCRIBER_REJECT = 'reject'
export const SUBSCRIBER_APPROVE = 'approve'
export const EXPORT_TYPE_ALL = 'all'
export const EXPORT_TYPE_SELECTED = 'selected'
export const EXPORT_TYPE_BY_STATUS = 'byStatus'

export const IS_PENDING = 2
export const BAD_CONTACT = 2
